const Component25 = ({ items, handleSelection, selectedCategory, selectedColor }) => {
  // Verifica che ci siano esattamente 25 elementi
  if (items.length !== 25) {
    return <div>Questo componente è progettato per 25 elementi!</div>;
  }

  const isOutOfStock = (item) => {
    const v = item?.out_of_stock;
    return v === 1 || v === true || v === "1" || v === "true";
  };

  const isNoneItem = (item) => item?.id === "none";

  const getItemClass = (item) => {
    const selected = selectedColor === item.id ? "selected-border" : "";
    const disabled = isOutOfStock(item) ? "disabled" : "";
    const none = isNoneItem(item) ? "grid-item-none" : "";
    return `${selected} ${disabled} ${none}`.trim();
  };

  // Slicing dell'array in sette parti
  const firstColumnItems = items.slice(0, 4);
  const secondColumnItem = items.slice(4, 7);
  const terzaColumnItem = items.slice(7, 11);
  const quartaColumnItem = items.slice(11, 14);
  const quintaColumnItem = items.slice(14, 18);
  const sestaColumnItem = items.slice(18, 21);
  const settimaColumnItem = items.slice(21, 25);

  return (
    <div
      className="row m-0"
      style={{
        gap: "10px",
        width: "100%",
        height: "100%",
      }}
    >
      {/* Prima colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {firstColumnItems.map((item, index) => (
          <div
            key={`first-column-${index}`}
            className={`grid-item ${getItemClass(item)}`}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "4px",
              height: "50%",
              color: "white",
              backgroundImage: `url("${item.bg}")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: item?.id === "none" ? "60% auto" : "cover",
            }}
            onClick={() => {
              if (isOutOfStock(item)) return;
              handleSelection(selectedCategory, item.id);
            }}
          />
        ))}
      </div>

      {/* Seconda colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {secondColumnItem.map((item, index) => (
          <div
            key={`second-column-${index}`}
            className={`grid-item ${getItemClass(item)}`}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "4px",
              height: "100%",
              color: "white",
              backgroundImage: `url("${item.bg}")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: item?.id === "none" ? "60% auto" : "cover",
            }}
            onClick={() => {
              if (isOutOfStock(item)) return;
              handleSelection(selectedCategory, item.id);
            }}
          />
        ))}
      </div>

      {/* Terza colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {terzaColumnItem.map((item, index) => (
          <div
            key={`terza-column-${index}`}
            className={`grid-item ${getItemClass(item)}`}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "4px",
              height: "50%",
              color: "white",
              backgroundImage: `url("${item.bg}")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: item?.id === "none" ? "60% auto" : "cover",
            }}
            onClick={() => {
              if (isOutOfStock(item)) return;
              handleSelection(selectedCategory, item.id);
            }}
          />
        ))}
      </div>

      {/* Quarta colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {quartaColumnItem.map((item, index) => (
          <div
            key={`quarta-column-${index}`}
            className={`grid-item ${getItemClass(item)}`}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "4px",
              height: "100%",
              color: "white",
              backgroundImage: `url("${item.bg}")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: item?.id === "none" ? "60% auto" : "cover",
            }}
            onClick={() => {
              if (isOutOfStock(item)) return;
              handleSelection(selectedCategory, item.id);
            }}
          />
        ))}
      </div>

      {/* Quinta colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {quintaColumnItem.map((item, index) => (
          <div
            key={`quinta-column-${index}`}
            className={`grid-item ${getItemClass(item)}`}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "4px",
              height: "100%",
              color: "white",
              backgroundImage: `url("${item.bg}")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: item?.id === "none" ? "60% auto" : "cover",
            }}
            onClick={() => {
              if (isOutOfStock(item)) return;
              handleSelection(selectedCategory, item.id);
            }}
          />
        ))}
      </div>

      {/* Sesta colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {sestaColumnItem.map((item, index) => (
          <div
            key={`sesta-column-${index}`}
            className={`grid-item ${getItemClass(item)}`}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "4px",
              height: "100%",
              color: "white",
              backgroundImage: `url("${item.bg}")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: item?.id === "none" ? "60% auto" : "cover",
            }}
            onClick={() => {
              if (isOutOfStock(item)) return;
              handleSelection(selectedCategory, item.id);
            }}
          />
        ))}
      </div>

      {/* Settima colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {settimaColumnItem.map((item, index) => (
          <div
            key={`settima-column-${index}`}
            className={`grid-item ${getItemClass(item)}`}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "4px",
              height: "100%",
              color: "white",
              backgroundImage: `url("${item.bg}")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: item?.id === "none" ? "60% auto" : "cover",
            }}
            onClick={() => {
              if (isOutOfStock(item)) return;
              handleSelection(selectedCategory, item.id);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default Component25;
